import { EventEmitter } from '@angular/core';
import { FOLDERABLE_APP_CONFIG } from 'FoldersApp/constants/folderable-app-config.constants';
import { ASC } from 'NewAngular/constants/core.constants';
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
import { TalkingPointsListPageSortColumn } from 'TalkingPointsApp/apps/talking-points-list-app/enums/talking-points-list.enum';
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import { FolderExpansionService } from 'FoldersApp/services/folder-expansion-service/folder-expansion.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import { AppStateManager } from 'NewAngular/services/app-state-manager.service';
import { TalkingPointFolderableCollectionListModalService } from 'TalkingPointsApp/apps/talking-points-list-app/services/talking-points-folderable-collection-list-modal.service';
import { TalkingPointsListAppStateService } from 'TalkingPointsApp/apps/talking-points-list-app/services/talking-points-list-app-state.service';
import { SelectedTalkingPointsService } from 'TalkingPointsApp/services/selected-talking-points.service';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/features/folders-shared/folderable-open-saved-modal/folderable-multi-select-saved-modal.component";
import * as i2 from "../talking-points-select-saved-list-item/talking-points-select-saved-list-item.component";
function TalkingPointsMultiSelectSavedModalComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-talking-points-select-saved-list-item", 2);
} if (rf & 2) {
    const folderable_r2 = ctx.folderable;
    const ancestorInfo_r3 = ctx.ancestorInfo;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("folderable", folderable_r2)("ancestorInfo", ancestorInfo_r3)("isMultiSelect", true)("maxItems", ctx_r3.maxItems || 99);
} }
export const TALKING_POINTS_FOLDERABLE_APP_CONFIG = {
    appName: 'TalkingPointsApp',
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Talking Points',
};
export class TalkingPointsMultiSelectSavedModalComponent {
    constructor() {
        this.showBackButton = false;
        this.selectionHandler = new EventEmitter();
        this.cancelHandler = new EventEmitter();
        this.backHandler = new EventEmitter();
        this.TalkingPointsSortColumn = TalkingPointsListPageSortColumn;
        this.SAVED_ITEM_COLUMN_CONFIG = {
            [TalkingPointsListPageSortColumn.NAME]: {
                label: 'name',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [TalkingPointsListPageSortColumn.USER_MODIFY_DATE]: {
                label: 'date modified',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [TalkingPointsListPageSortColumn.OWNER_NAME]: {
                label: 'owner',
                numCssCols: 2,
                defaultSortDirection: ASC,
            },
        };
        this.SAVED_ITEM_FILTER_DEFAULT = {
            owner: { me: true, shared_with_me: true, public: true },
            page: 1,
            sortColumn: TalkingPointsListPageSortColumn.USER_MODIFY_DATE,
            sortDirection: ASC,
            name: '',
            includeEmptyFolders: true,
        };
    }
}
TalkingPointsMultiSelectSavedModalComponent.ɵfac = function TalkingPointsMultiSelectSavedModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointsMultiSelectSavedModalComponent)(); };
TalkingPointsMultiSelectSavedModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TalkingPointsMultiSelectSavedModalComponent, selectors: [["ycn-talking-points-multi-select-saved-modal"]], inputs: { maxItems: "maxItems", showBackButton: "showBackButton" }, outputs: { selectionHandler: "selectionHandler", cancelHandler: "cancelHandler", backHandler: "backHandler" }, standalone: false, features: [i0.ɵɵProvidersFeature([
            TalkingPointFolderableCollectionListModalService,
            SelectedTalkingPointsService,
            BulkActionSelectionService,
            FolderExpansionService,
            {
                provide: FolderableCollectionServiceBase,
                useExisting: TalkingPointFolderableCollectionListModalService,
            },
            {
                provide: SelectedFolderableService,
                useExisting: SelectedTalkingPointsService,
            },
            {
                provide: AppStateManager,
                useExisting: TalkingPointsListAppStateService,
            },
            { provide: FOLDERABLE_APP_CONFIG, useValue: TALKING_POINTS_FOLDERABLE_APP_CONFIG },
        ])], decls: 3, vars: 11, consts: [["listItemFragment", ""], [3, "selectionHandler", "backHandler", "cancelHandler", "modalHeader", "columnConfig", "sortableColumns", "userPreferenceFilterKey", "filterDefault", "listItemFragment", "publicSharing", "userHasNoDataMessage", "loadingMessage", "loadingTestId", "showBackButton"], [3, "folderable", "ancestorInfo", "isMultiSelect", "maxItems"]], template: function TalkingPointsMultiSelectSavedModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-folderable-multi-select-saved-modal", 1);
        i0.ɵɵlistener("selectionHandler", function TalkingPointsMultiSelectSavedModalComponent_Template_ycn_folderable_multi_select_saved_modal_selectionHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectionHandler.emit($event)); })("backHandler", function TalkingPointsMultiSelectSavedModalComponent_Template_ycn_folderable_multi_select_saved_modal_backHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.backHandler.emit()); })("cancelHandler", function TalkingPointsMultiSelectSavedModalComponent_Template_ycn_folderable_multi_select_saved_modal_cancelHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.cancelHandler.emit()); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, TalkingPointsMultiSelectSavedModalComponent_ng_template_1_Template, 1, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const listItemFragment_r5 = i0.ɵɵreference(2);
        i0.ɵɵproperty("modalHeader", "Select Talking Points")("columnConfig", ctx.SAVED_ITEM_COLUMN_CONFIG)("sortableColumns", ctx.TalkingPointsSortColumn)("userPreferenceFilterKey", "talking_points_list_modal_filters")("filterDefault", ctx.SAVED_ITEM_FILTER_DEFAULT)("listItemFragment", listItemFragment_r5)("publicSharing", true)("userHasNoDataMessage", "Get Started.<br><span>Create a new Talking Point</span>")("loadingMessage", "Loading Talking Points...")("loadingTestId", "talking-points-loading-symbol")("showBackButton", ctx.showBackButton);
    } }, dependencies: [i1.FolderableMultiSelectSavedModalComponent, i2.TalkingPointsSelectSavedListItemComponent], encapsulation: 2 });
